export default "https://cdn-static.gokick.com/assets/ea2c661fec3366c14365f7d1c68d2a3d0c715dc9/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";